import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';

export default class ComponentTabs extends Component {
    render() {
        return (
            <div className='centered-block loading'>
                <Spinner
                    animation='border'
                    role='status'
                    style={{
                        width: '3.2rem',
                        height: '3.2rem',
                        borderWidth: '.3rem',
                    }}>
                    <span className='sr-only'>Loading...</span>
                </Spinner>
            </div>
        );
    }
}
